import { cv, type CvLink } from '@/data/cv';
import { entities } from '@/data/sources/pulse/entities';

const projectStats: Record<string, string> = {
  TabPilot: '200+ paying customers · featured on the Mac App Store',
};

const projectLinks: Record<string, CvLink[]> = {
  TabPilot: [
    {
      label: 'App Store',
      href: 'https://apps.apple.com/us/app/tabpilot/id6760547850',
    },
  ],
  Thamira: [
    {
      label: 'App Store',
      href: 'https://apps.apple.com/us/app/thamira/id1567818332',
    },
    {
      label: 'Google Play',
      href: 'https://play.google.com/store/apps/details?id=com.ondrejbarta.thamira',
    },
  ],
};

const CLIENT_ORGS = new Set(['Kilta']);

const kiltaPulseIds = entities
  .filter((e) => e.parent === 'Kilta')
  .map((e) => e.id);

const projectPulseIds: Record<string, string[]> = {
  TabPilot: ['TabPilot'],
  GitPT: ['GitPT'],
  Lensta: ['Lensta'],
  Thamira: ['Thamira'],
  'ondrejbarta.com': ['ondrejbarta.com'],
};

const slugify = (name: string) =>
  name
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();

export type Item = {
  key: string;
  anchor: string;
  title: string;
  period?: string;
  sub?: string;
  subHref?: string;
  stat?: string;
  paragraphs: string[];
  links: CvLink[];
  pulseIds: string[];
};

const fromExperience = (org: (o: string) => boolean): Item[] =>
  cv.experience
    .filter((e) => org(e.org))
    .map((e) => ({
      key: `${e.org}-${e.period}`,
      anchor: slugify(e.org),
      title: e.role,
      period: e.period,
      sub: e.org,
      subHref: e.orgHref,
      paragraphs: e.paragraphs,
      links: [],
      pulseIds: CLIENT_ORGS.has(e.org) ? [e.org, ...kiltaPulseIds] : [e.org],
    }));

export const workItems = fromExperience((o) => !CLIENT_ORGS.has(o));
export const clientItems = fromExperience((o) => CLIENT_ORGS.has(o));
export const projectItems: Item[] = cv.sideProjects.map((p) => ({
  key: p.name,
  anchor: slugify(p.name),
  title: p.name,
  period: p.period,
  sub: p.org,
  stat: projectStats[p.name],
  paragraphs: p.paragraphs,
  links: [...(p.links ?? []), ...(projectLinks[p.name] ?? [])],
  pulseIds: projectPulseIds[p.name] ?? ['Personal'],
}));
